import serviceAccount from "../weme-app-4b0ec-firebase-adminsdk-fbsvc-f3d0753790.json";
import admin from "firebase-admin";

// באדמין firebase-admin מוחלף ב-stub ({}), אז admin.apps undefined – לא לגשת ל-.length בלי optional chaining
const hasNoApps = !admin?.apps || (admin.apps?.length ?? 0) === 0;
if (typeof admin?.initializeApp === "function" && hasNoApps) {
  admin.initializeApp({
    credential: admin.credential.cert({
      clientEmail: serviceAccount.client_email,
      privateKey: serviceAccount.private_key,
      projectId: serviceAccount.project_id,
    }),
  });
}

export default admin;
